import React, {Fragment, useEffect, useMemo, useState} from 'react';
import {Avatar} from "antd";
import { Comment as AntComment} from "@ant-design/compatible"
import {getUrl} from "../../../service/files.service";
import StickerComment from "../../../pages/Home/Post/StickerComment";
import Lottie from "lottie-react";
import heartLogo from "../../shared/Heart/like.json";
import {getUserData} from "../../../service/auth.service";
import {usePrevious} from "../../../hooks/usePrevious";
import useFetch, {CachePolicies} from "use-http";
import {DeleteOutlined, EditOutlined} from "@ant-design/icons";
import moment from "moment";
import {useTranslation} from "react-i18next";
import CenterConfirmModal from "../../shared/Modal/CenterConfirmModal";
import Lightbox from "react-image-lightbox";
import {ProfilePopover} from "../../Popover";

const expURL = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,256}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/g;

interface Comment {
    id: string
    imgURL: string
    name: string
    data: any
    content: any
    isLike: boolean
    date: any
    likeUsers: any[]
    onLike: (commentId: string) => void
    onUnlike: (commentId: string) => void
    onEdit: (commentId: string) => void
    onDelete: (commentId: string) => void
}

export const Comment: React.FunctionComponent<Comment> = (props) => {
    const { t } = useTranslation();
    const [url300, setUrl300] = useState<string>("");
    const [url1024, setUrl1024] = useState<string>("");

    const [isLike, setIsLike] = useState<boolean>(props.isLike);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [openImage, setOpenImage] = useState<boolean>(false);

    const prevIsLike: boolean = usePrevious(isLike);

    const likeCommentAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/comment/like",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const unlikeCommentAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/comment/like/delete",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const deleteCommentAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/comment/delete",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const checkGetUrlFile = async () => {
        if (props.data?.covers?.length > 0) {
            let url: any =
                window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER +
                "/downloadFile?fileId=" +
                props.data?.covers[0]?.imageID +
                "&size=300";
            url = await getUrl(url, props.data?.covers[0]?.imageID, 300, "post");
            setUrl300(url);
        }
    };

    const checkGetUrlFile1024 = async () => {
        if (props.data?.covers?.length > 0) {
            let url: any =
                window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER +
                "/downloadFile?fileId=" +
                props.data?.covers[0]?.imageID +
                "&size=1024";
            url = await getUrl(url, props.data?.covers[0]?.imageID, 1024, "post");
            setUrl1024(url);
        }
    };

    const toggleLike = async () => {
        if (isLike) {
            handleUnlike();
        } else {
            handleLike();
        }
    }

    const handleLike = async () => {
        try {
            let body = {
                feedID: props.data?.feedID,
                commentID: props.data?.id,
            };

            await likeCommentAPI.post(body);

            if (likeCommentAPI.response.ok) {
                setIsLike(true);
                props.onLike(props.data?.id)
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleUnlike = async () => {
        try {
            await unlikeCommentAPI.delete(`/${props.data?.id}`);

            if (unlikeCommentAPI.response.ok) {
                setIsLike(false);
                props.onUnlike(props.data?.id)
                // setLikeCount(likeCount - 1);
                // props?.refresh();
            }
        } catch (error) {
            console.error(error);
        }
    };

    const renderCommentText = useMemo(() => {
        let contentTextEl: any = [];
        if (props?.data?.mentionObj) {
            const mentionObj = JSON.parse(props?.data?.mentionObj);
            const entityRanges = mentionObj?.rangeList[0]?.entityRanges;
            const text = props?.data?.type === "sticker" ? props?.data?.stickerContent : props?.content;

            let currentIdx = 0;
            let nextMention = text.indexOf("@");

            for (let i = 0; i < entityRanges.length; i++) {
                if (currentIdx < nextMention && nextMention !== -1) {
                    const txt = text.substring(currentIdx, nextMention);
                    console.log("txt1 ", txt)
                    let isUrl = txt.match(expURL);
                    if (isUrl?.length > 0) {
                        const textEl = <a href={txt} target="_blank" key={`${currentIdx}`}>{txt}</a>;
                        contentTextEl.push(textEl);
                        currentIdx = nextMention;
                    } else {
                        const textEl = <span key={`${currentIdx}`}>{txt}</span>;
                        contentTextEl.push(textEl);
                        currentIdx = nextMention;
                    }

                }

                if (
                    currentIdx === nextMention &&
                    nextMention === entityRanges[i]?.offset
                ) {
                    const start = entityRanges[i]?.offset;
                    const end = entityRanges[i]?.offset + entityRanges[i]?.length;
                    const mentionTxt = text.substring(start, end);
                    const mentionEl = (
                        <span
                            key={`${start}${currentIdx}`}
                            style={{color: "#48c9b0", cursor: "pointer"}}
                            onClick={() => {
                                const user = mentionObj?.mapList?.find((u: any) => {
                                    return u?.key === entityRanges[i]?.key.toString();
                                });
                                // props?.onClickMention(user?.userId);
                            }}
                        >
              {mentionTxt}
            </span>
                    );
                    contentTextEl.push(mentionEl);
                    const remainText = text.substring(end);
                    currentIdx = end;
                    nextMention =
                        remainText.indexOf("@") === -1
                            ? -1
                            : currentIdx + remainText.indexOf("@");
                }

                if (nextMention === -1) {
                    const txt = text.substring(currentIdx);
                    let isUrl = txt.match(expURL);
                    if (isUrl?.length > 0) {
                        const textEl = <a href={txt} target="_blank" key={`${currentIdx}`}>{txt}</a>;
                        contentTextEl.push(textEl);
                    } else {
                        const textEl = <span key={`${currentIdx}`}>{txt}</span>;
                        contentTextEl.push(textEl);
                    }

                }
            }
            return contentTextEl;
        } else {
            const text = props?.data?.type === "sticker" ? props?.data?.stickerContent : props?.content;
            let isHaveUrl = text?.match(expURL);
            if (isHaveUrl?.length > 0) {
                let textList = text?.split(" ");
                return textList?.map((txt: any) => {
                    let isUrl = txt.match(expURL);
                    if (isUrl?.length > 0) {
                        return (<a href={txt} target="_blank">{txt} </a>);
                    } else {
                        return <span>{txt} </span>;
                    }
                });
            }
            return text;
        }

    }, [props.data]);

    const likeCount: number = useMemo(() => {
        // console.log("props.data?.likeUsers", props.data?.likeUsers.length)
        return props.likeUsers.length
    }, [props.likeUsers])

    const isOwner: boolean = useMemo(() => {
        return getUserData().id === props.data?.user?.id;
    }, [props.data])

    // const isLike = useMemo(() => {
    //     return props.data?.likeUsers?.some((user: any) => {
    //         return user.userID === getUserData().id;
    //     });
    // }, [props.data])

    useEffect(() => {
        checkGetUrlFile();
        checkGetUrlFile1024();
    }, [props.data]);

    const dateTimePost = (postTime: any) => {
        let lang = localStorage.getItem("lang");
        if ( lang === "th" ) {
            let dt = moment(postTime).format(`DD MMMM YYYY HH:mm`);
            let t_date = dt.split(" ")[0];
            let t_month = t(dt.split(" ")[1]);
            let t_year = dt.split(" ")[2];
            let t_time = dt.split(" ")[3];
            return `${t_date} ${t_month} ${parseInt(t_year)+543}, ${t_time} น.`;
        } else {
            return moment(postTime).format("DD MMMM YYYY hh:mm A");
        }
    }

    const handleDeleteComment = async () => {
        try {
            await deleteCommentAPI.delete(`/${props.id}`);
            setShowDeleteModal(false);
            props.onDelete(props.id);
        } catch (e) {
            console.error(e);
        }
    };

    const handleClickImage = () => {
        setOpenImage(true);
    };

    return (
        <AntComment
            avatar={
                <ProfilePopover userId={props.data?.user?.id} imgURL={props.imgURL} name={props.name}>
                    <Avatar size={40} style={{ cursor: "pointer" }} src={props.imgURL} />
                </ProfilePopover>
            }
            content={
                <Fragment>
                    <div style={{
                        padding: ".75rem 1.5rem",
                        borderRadius: "20px",
                        backgroundColor: "#F5F5F5",
                        width: "fit-content",
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        <p style={{
                            fontWeight: "bold",
                            backgroundColor: "#F5F5F5",
                            marginBottom: ".75rem",
                            width: "100%",
                            minWidth: "200px",
                            // maxWidth: "200px",
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            {props.name}
                            <div className="heart-btn"
                                 style={{
                                     // width: 40,
                                     // height: 40,
                                     // marginLeft: "-9px",
                                     cursor: "pointer",
                                     display: "flex",
                                     justifyContent: "center",
                                     alignItems: "center",
                                 }}
                                 onClick={toggleLike}
                            >
                                {
                                    isLike &&
                                    <Lottie
                                        animationData={heartLogo}
                                        autoplay={true}
                                        loop={false}
                                        initialSegment={[prevIsLike === undefined ? 36 : 0, 36]}
                                        style={{width: 24, height: 24, pointerEvents: "none"}}
                                    />
                                }
                                {!isLike &&
                                    <Lottie
                                        animationData={heartLogo}
                                        autoplay={true}
                                        loop={false}
                                        initialSegment={[0, 1]}
                                        style={{width: 24, height: 24, pointerEvents: "none"}}
                                    />
                                }
                                {likeCount > 0 &&
                                <div style={{fontSize: "12px", marginLeft: 0, color: "#BEBEBE"}}>
                                    {likeCount}
                                </div>
                                }
                            </div>
                        </p>
                        <span style={{wordBreak: "break-all"}}>
                            {renderCommentText}
                        </span>
                        {props.data?.type === "sticker" && (
                            <StickerComment
                                key={"message_img_" + props.data?.stickerId}
                                // id={
                                //   props.data?.stickerType === "default"
                                //     ? props.data?.stickerId
                                //     : props.data?.transactionId + "_" + props.data?.stickerId
                                // }
                                stickerType={props.data?.stickerType}
                                stickerId={props.data?.stickerId}
                                // src={props.content}
                            />
                        )}
                        {props.data?.type === "image" && (
                            <img
                                width="100%"
                                height="100%"
                                src={url300}
                                onClick={handleClickImage}
                                style={{
                                    // marginTop: 10,
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    maxWidth: "200px",
                                    maxHeight: "300px",
                                }}
                            />
                        )}
                    </div>
                    <div style={{
                        marginTop: "0.25rem",
                        display: "flex",
                        textAlign: "center",
                        alignItems: "center",
                        justifyContent: "space-between",
                        height: "24px"
                    }}>
                        <span style={{
                            fontSize: "12px",
                            color: "#BEBEBE",
                        }}>
                            {dateTimePost(props.date)}
                        </span>
                        <div style={{
                            color: "#BEBEBE",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            {isOwner &&
                                <Fragment>
                                    <EditOutlined
                                        style={{margin: "0 0.25rem", cursor: "pointer"}}
                                        onClick={() => props.onEdit(props.id)}
                                    />
                                    <DeleteOutlined
                                        style={{margin: "0 0.25rem", cursor: "pointer"}}
                                        onClick={() => setShowDeleteModal(true)}
                                    />
                                </Fragment>
                            }
                            {/*{likeCount !== 0 && (*/}
                            {/*    <div style={{*/}
                            {/*        display: "flex",*/}
                            {/*        alignItems: "center"*/}
                            {/*    }}>*/}

                            {/*        <Lottie*/}
                            {/*            animationData={heartLogo}*/}
                            {/*            autoplay={true}*/}
                            {/*            loop={false}*/}
                            {/*            initialSegment={[0, 1]}*/}
                            {/*            style={{width: 24, height: 24, pointerEvents: "none"}}*/}
                            {/*        />*/}
                            {/*        <div style={{fontSize: "12px", marginLeft: 0, color: "#BEBEBE"}}>*/}
                            {/*            {likeCount}*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*)}*/}
                        </div>
                    </div>
                    <CenterConfirmModal
                        visible={showDeleteModal}
                        onCancel={() => {
                            setShowDeleteModal(false);
                        }}
                        confirmLoading={deleteCommentAPI.loading}
                        onConfirm={handleDeleteComment}
                        text={t("Are you sure to delete this Comment")}
                        confirmText={t("OK")}
                        cancelText={t("Cancel")}
                    />
                    {openImage && (
                        <Lightbox
                            wrapperClassName={"lightboxOverride"}
                            mainSrc={url1024}
                            onCloseRequest={() => setOpenImage(false)}
                        />
                    )}
                </Fragment>
            }
        />
    )
}